var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowsCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon--arrows-circle",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2996_3959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 2.00001C10.6155 1.99801 9.21511 2.28678 7.89111 2.88478L8.90087 4.63282C9.90487 4.20982 10.9575 3.99801 12.0005 4.00001C15.0813 4.00001 17.739 5.76333 19.0747 8.32227L17.1255 9.00001L21.2505 11L22.8755 7.00001L20.9985 7.65235C19.3782 4.31105 15.9563 2.00001 12.0005 2.00001L12.0005 2.00001ZM6.51025 4.48829L2.23291 5.08204L3.73486 6.38087C1.65202 9.45507 1.36208 13.5746 3.34033 17C4.03133 18.201 4.98064 19.2682 6.16064 20.1152L7.17041 18.3672C6.30241 17.7102 5.59275 16.904 5.07275 16C3.53249 13.3324 3.72969 10.1487 5.27783 7.7129L6.84033 9.06251L6.51025 4.48829ZM19.9302 13C19.7952 14.08 19.4512 15.098 18.9282 16C17.3875 18.6685 14.5318 20.0906 11.647 19.9668L12.0356 17.9375L8.24072 20.5117L10.8931 23.918L11.2661 21.9668C14.9694 22.2338 18.6824 20.4263 20.6606 17C21.3556 15.801 21.8057 14.445 21.9497 13H19.9302Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2996_3959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowsCircle);
export default __webpack_public_path__ + "static/media/icon--arrows-circle.47c73e42c4650737aa5adca50ee5c0cc.svg";
export { ForwardRef as ReactComponent };